<div class="{direction} panels" part="panels">
  {>slot}
</div>
